export function isEmpty(text?: string | null) {
  if (!text) return true;
  text = text.trim();
  if (text == "") return true;
  if (text == "<p></p>") return true;
  return false;
}

/**
 * Returns a shortened version of the title,
 * removing common words and abbreviating the rest.
 */
export function abbreviateTitle(title: string) {
  if (title.length < 10) return title;
  let shortenedTitle = title
    .split(" ")

    // remove common words
    .filter(
      (w) =>
        ![
          "the",
          "a",
          "der",
          "den",
          "die",
          "das",
          "ein",
          "eine",
          "alle",
          "all",
          "is",
          "ist",
          "wird",
          "von",
          "hat",
          "hatte",
          "has"
        ].includes(w.toLocaleLowerCase())
    )
    .join(" ")
    .substring(0, 10)
    .trim();
  if (shortenedTitle.length < title.length) shortenedTitle += "...";
  return shortenedTitle;
}

/**
 * Strips HTML tags from a string.
 * @param text The input string containing HTML.
 * @returns The input string without HTML tags.
 */
export function stripHtmlTags(text?: string | null): string {
  // Always return a string; treat nullish as empty.
  if (!text) return "";

  // Parse in an isolated document; DOMParser does not execute scripts.
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");

  // Remove potentially dangerous/irrelevant nodes even though we only read text.
  // This is defensive and avoids surprises with e.g. <style> text leaking in.
  doc.querySelectorAll("script, style, iframe, object, embed, link, meta, noscript").forEach((el) => el.remove());

  // Prefer innerText to preserve visual line breaks (<br>, block elements).
  // Fall back to textContent if innerText is unavailable.
  const body: any = doc.body;
  const raw: string = (typeof body.innerText === "string" ? body.innerText : body.textContent) ?? "";

  // Normalize non-breaking spaces and trim outer whitespace.
  return raw.replace(/\u00A0/g, " ").trim();
}

export default {
  isEmpty,
  stripHtmlTags
};
